<app-nav *ngIf="showNav"></app-nav>
<router-outlet></router-outlet>

<!-- <landing-animation *ngIf="newUserUX" (onComplete)="onAnimationComplete()"></landing-animation> -->